<div class="d-flex">
  <app-field-action
    [option]="{
      text: '$lbl.latLong' | translate,
      icon: 'fas fa-share'
    }"
    (emitClick)="setNewModal(dumpster)"
  >
    <input type="string" step="any" class="form-control field-body" formControlName="location" />
  </app-field-action>
</div>

<ng-template windowVisualizer></ng-template>
